export default function getHeaders(
  token?: string,
  sessionKey?: string,
  isMultipart: boolean = false,
  includeSessionKey: boolean = true
) {

  const headers: HeadersInit = {
    Accept: "application/json",
  };

  if (!isMultipart) {
    headers["Content-Type"] =
      "application/json";
  }

  if (token) {
    headers["Authorization"] =
      `Bearer ${token}`;
  }

  if (
    includeSessionKey &&
    sessionKey
  ) {
    headers["sessionKey"] =
      sessionKey;
  }

  return headers;
}